// Animate Background Circles and Image
if (document.querySelector('.page-header')) {
  const pageHeaderBgCircle = document.querySelector('.page-header__bg-circle');
  const pageHeaderBgImage = document.querySelector('.page-header__bg-image');

  if (pageHeaderBgCircle || pageHeaderBgImage) {
    const pageHeaderImgTimeline = gsap.timeline({ duration: 0.1 });
    gsap.set('.page-header__bg-image-left', { xPercent: -100 });
    gsap.set('.page-header__bg-image-right', { xPercent: 100 });
    const mm = gsap.matchMedia();

    // Bg Image
    pageHeaderImgTimeline
      .to('.page-header__bg-image-left', {
        xPercent: 0,
      })
      .to(
        '.page-header__bg-image-right',
        {
          xPercent: 0,
        },
        '-=0.2',
      );

    mm.add('(min-width: 1023px)', () => {
      gsap.to('.page-header__bg-circle--left', {
        yPercent: -15,
        scrollTrigger: {
          trigger: '.page-header',
          start: 'top 10%',
          end: 'bottom top',
          scrub: 3,
        },
      });

      gsap.to('.page-header__bg-circle--right', {
        yPercent: 20,
        scrollTrigger: {
          trigger: '.page-header',
          start: 'top 10%',
          end: 'bottom top',
          scrub: 3,
        },
      });

      // Bg Image
      gsap.to('.page-header__bg-image-left', {
        yPercent: -20,
        scrollTrigger: {
          trigger: '.page-header',
          start: 'top 10%',
          end: 'bottom top',
          scrub: 3,
        },
      });

      gsap.to('.page-header__bg-image-right', {
        yPercent: 20,
        scrollTrigger: {
          trigger: '.page-header',
          start: 'top 10%',
          end: 'bottom top',
          scrub: 3,
        },
      });
    });
  }
}
